import { useMutation } from "@shared/lib/hooks";

import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";

export function useExportCampaignInfluencers(handleSuccess?: () => void) {
  const {
    mutate: exportCampaignInfluencers,
    isLoading: isExporting,
    isSuccess: isExported,
  } = useMutation({
    mutationFn: async (briefId: string) => {
      return await CampaignService.downloadCampaignInfluencers(briefId).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, _) => {
      c.invalidateQueries({
        queryKey: [...DOWNLOADS_LIST_QUERY_KEY],
        exact: false,
      });
      handleSuccess?.();
    },
  });
  return {
    exportCampaignInfluencers,
    isExporting,
    isExported,
  };
}
